import { useSyncExternalStore } from "react";
import { http } from "@/util/fetch";
import { createDummyStore } from "./dummy-store";

const { subscribe, emitChange } = createDummyStore();

let save_slow_state = false;

export async function saveSlow(debug_info_array: unknown[]) {
  if (!save_slow_state) {
    save_slow_state = true;

    emitChange();
  }

  await save_debug_info(debug_info_array);
}

export function saveSucceeded() {
  if (!save_slow_state) {
    return;
  }

  save_slow_state = false;

  emitChange();
}

const getSnapshot = () => save_slow_state;

export function useIsSlowSaving() {
  return useSyncExternalStore(subscribe, getSnapshot);
}

async function save_debug_info(debug_info_array: unknown[]) {
  const url = "/api/v2/debug_info";
  try {
    await http.post(url, {
      body: { debug_info: { debug_info_array } },
      safe: true,
      skipLoadingIndicator: true,
    });
  } catch {
    // ignore errors - this is just debug info
  }
}
